function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var __script__ = {
  props: {
    row: Object,
    prefixCls: String,
    draggable: Boolean
  },
  computed: {
    objData: function objData() {
      return this.$parent.objData;
    }
  },
  methods: {
    onDrag: function onDrag(e, index) {
      e.dataTransfer.setData('index', index);
    },
    onDrop: function onDrop(e, index) {
      var dragIndex = e.dataTransfer.getData('index');
      this.$parent.$parent.dragAndDrop(dragIndex, index);
      e.preventDefault();
    },
    allowDrop: function allowDrop(e) {
      e.preventDefault();
    },
    rowClasses: function rowClasses(_index) {
      var _ref;

      return [this.prefixCls + '-row', this.rowClsName(_index), (_ref = {}, _defineProperty(_ref, this.prefixCls + '-row-highlight', this.objData[_index] && this.objData[_index]._isHighlight), _defineProperty(_ref, this.prefixCls + '-row-hover', this.objData[_index] && this.objData[_index]._isHover), _ref)];
    },
    rowClsName: function rowClsName(_index) {
      return this.$parent.$parent.rowClassName(this.objData[_index], _index);
    }
  }
};

var render = function render() {
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
  return _vm.draggable ? _c('tr', {
    class: _vm.rowClasses(_vm.row._index),
    attrs: {
      "draggable": _vm.draggable
    },
    on: {
      "dragstart": function dragstart($event) {
        return _vm.onDrag($event, _vm.row._index);
      },
      "drop": function drop($event) {
        return _vm.onDrop($event, _vm.row._index);
      },
      "dragover": function dragover($event) {
        return _vm.allowDrop($event);
      }
    }
  }, [_vm._t("default")], 2) : _c('tr', {
    class: _vm.rowClasses(_vm.row._index)
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
var __template__ = { render: render, staticRenderFns: staticRenderFns };

export default Object.assign({}, __script__, __template__);